import { Text } from 'foundations-components/components/Text';
import { useMemo } from 'react';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import styled from 'styled-components';
import { LlmSanitizerConfig } from './LlmSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const BACKTICK_REGEX = /`([^`]+)`/g;
const replaceBackticksWithCodeBlocks = text => text.replace(BACKTICK_REGEX, '<code class="inline-code-snippet" role="code">$1</code>');

/* @bend-expect no-styled-foundations-components */
const StyledText = styled(Text).withConfig({
  displayName: "Markdown__StyledText"
})(["li > p{margin-bottom:0px;}> *:last-child{margin-bottom:0px;}"]);
const Markdown = ({
  html
}) => {
  const sanitizedHtml = useMemo(() => {
    return sanitize(html, LlmSanitizerConfig);
  }, [html]);
  const decoratedHtml = useMemo(() => {
    const htmlWithCodeDecorations = replaceBackticksWithCodeBlocks(sanitizedHtml);
    return htmlWithCodeDecorations;
  }, [sanitizedHtml]);
  return /*#__PURE__*/_jsx(StyledText, {
    as: "span",
    whiteSpace: "pre-line",
    dangerouslySetInnerHTML: {
      __html: decoratedHtml
    }
  });
};
export default Markdown;